import { LOGIN_REQUESTING, LOGOUT_REQUESTING } from '../../../redux/constants/shared/loginUserConstants';

export const logoutSuccessful = (isTimeOut) => ({type: LOGOUT_REQUESTING, isTimeOut: isTimeOut});
export const loginRequesting = () => ({type: LOGIN_REQUESTING});
